const Nopage=()=>{
    return (<div className='flex justify-center pt-[12rem]'>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <h1 className='text-4xl sm:text-6xl md:text-8xl text-[#998147]'>Not Found</h1>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
         <br></br>
    </div>
    );
}

export default Nopage;